<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-custom-cell-sample">
    <div class="image" @click="handleClick">{{row[column.name]}}</div>
  </div>
</template>

<script>
export default {
  name: 'wy-custom-cell-sample',
  props: ['controller', 'column', 'row', 'index'],

  methods: {
    handleClick() {

    }
  }
}
</script>
